export const USED_FONTS = {
    'BMWNext': {
        uri: require('@/assets/fonts/BMWTypeNext-Regular.otf'),
        display: 'swap',
    },
    'BMWNext-Bold': {
        uri: require('@/assets/fonts/BMWTypeNext-Bold.otf'),
        display: 'swap',
    },
};